import { apiSlice } from "../../api/ApiService";

const postAdminUserApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    addAdminUser: builder.mutation({
        // query:  ({ accessToken, addAdmin }: { accessToken: string | null, addAdmin: Object }) => ({
          query: ({ body, accessToken }) => ({
          url: `/api/v1/Administration/admin-user`,
          method: "POST",
          data: body,
          headers: {
          accept: "*/*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      invalidatesTags: (result, error) => [
        { type: "AdminList" },
      ],
    })
  }),
  overrideExisting: false
});

export const { useAddAdminUserMutation } = postAdminUserApi;
export default postAdminUserApi;
